import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {toast} from 'react-toastify';
import {ELEMENT} from '../../../../../incase-domain/elements/base/ElementTypes';
import {IElementQuestionnaire} from '../../../../../incase-domain/elements/base/questionElementBase';
import {QuestionElementInteractions, QuestionnaireElementInteraction} from '../../../../../incase-domain/proptypes/runfile';
import {loadedPresentationSelector} from '../../../../../store/selectors/presentation.selectors';
import {isQuestionRetriable} from '../../../../../util/util';
import {getAttemptsAndRetriable} from '../../../../../incase-domain/utils/retryCount';

export function useQuestionRemainingToast(): {
    emitRemainingTriesToast: (element: IElementQuestionnaire, elementInteractions: QuestionnaireElementInteraction) => void;
} {
    const {t} = useTranslation();
    const presentation = useSelector(loadedPresentationSelector);

    function emitRemainingTriesToast(element: IElementQuestionnaire, elementInteractions: QuestionElementInteractions): void {
        const attemptsData = getAttemptsAndRetriable(element, presentation);

        if (
            isQuestionRetriable(element, presentation) &&
            (element.singleCorrect || element.haveTryButton || element.type === ELEMENT.SEQUENCE_QUESTION)
        ) {
            const remainingAttempts: number =
                (attemptsData?.maxAttempts || 2) -
                (elementInteractions.retriedAnswers?.length || 0) -
                (elementInteractions.answered ? 1 : 0);

            toast.error(t('retryQuestion.remainingAttempts', {count: remainingAttempts - 1}));
        }
    }

    return {emitRemainingTriesToast};
}
